import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import "@/app/globals.css";
import "katex/dist/katex.min.css";
import { reloadOnceForStaleChunk } from "@/lib/lazyWithRetry";
import { queryClient } from "@/lib/query";
import { router } from "@/router";

// Recover stale clients after a deploy: Vite fires `vite:preloadError` when a
// hashed chunk referenced by the running bundle can no longer be fetched. A
// one-time reload pulls the fresh index.html pointing at the current assets.
// Vite dispatches this event for preload failures, including static dependencies
// of the lazy SuperDoc chunk. The outer `lazyWithRetry` import catches failures
// of the chunk itself; the error boundary remains the final UI for other errors.
window.addEventListener("vite:preloadError", () => {
  reloadOnceForStaleChunk();
});

const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <RouterProvider router={router} context={{ queryClient }} />
  </StrictMode>,
);
